import React from "react";
import { Edit, useForm } from "@refinedev/antd";
import { Form, Input } from "antd";

export const CategoryEdit: React.FC = () => {
  const { formProps, saveButtonProps } = useForm();

  return (
    <Edit
      saveButtonProps={saveButtonProps}
      contentProps={{ variant: "borderless" }}
    >
      <Form {...formProps} layout="vertical">
        <Form.Item label="ID" name="id">
          <Input disabled />
        </Form.Item>

        <Form.Item
          label="名称"
          name="name"
          rules={[{ required: true, message: "请输入分类名称" }]}
        >
          <Input placeholder="如：动作、喜剧..." />
        </Form.Item>

        <Form.Item
          label="Slug"
          name="slug"
          rules={[
            { required: true, message: "请输入 slug" },
            {
              pattern: /^[a-z0-9-]+$/,
              message: "仅支持小写字母、数字和短横线",
            },
          ]}
          extra="用于 URL/别名，建议小写英文，例如 action、drama"
        >
          <Input />
        </Form.Item>

        <Form.Item label="描述" name="description">
          <Input.TextArea rows={3} />
        </Form.Item>
      </Form>
    </Edit>
  );
};
